// atoms/variantFilters.ts
import { atom } from 'jotai';

export const variantFilterAtom = atom(0); // default to 0
